import { Xhr } from 'tortilla';

export default class {
    constructor() {
        this.inProgressCount = 0;
    }

    upload(event) {
        this.incrementCount();
        
        return Xhr.post('api/attachment', this.getData(event))
            .then((result) => {
                this.decrementCount();
                return result;
            });
    }

    getData(event) {
        const target = event.target;

        if(!target.files) {
            return {};
        }

        const data = new FormData();
        
        data.append('attachment', target.files.item(0));
        data.append('_method', 'put');

        return data;
    }

    waitingOnUploads() {
        return !! this.inProgressCount;
    }

    incrementCount() {
        ++this.inProgressCount;
    }

    decrementCount() {
        --this.inProgressCount;
    }
}
